import type {
  KitchenOrder,
  KitchenOrderMapped,
  KitchenProduct,
  KitchenProductMapped
} from '@/types'

export function mapKitchenOrder(order: KitchenOrder): KitchenOrderMapped {
  const newVersion = order.versions.slice(-1)[0]
  const oldVersion = order.versions.length > 1 ? order.versions.slice(-2)[0] : newVersion

  const hasModifications = order.versions.length > 1

  const oldProductsMap = new Map<string, KitchenProduct>()
  const newProductsMap = new Map<string, KitchenProduct>()

  oldVersion.products.forEach(p => oldProductsMap.set(p.id, p))
  newVersion.products.forEach(p => newProductsMap.set(p.id, p))

  const allProductIds = new Set([...oldProductsMap.keys(), ...newProductsMap.keys()])

  const mappedProducts: KitchenProductMapped[] = Array.from(allProductIds).map(productId => {
    const oldProduct = oldProductsMap.get(productId)
    const newProduct = newProductsMap.get(productId)

    const product = (newProduct || oldProduct)!
    const deleted = !newProduct && !!oldProduct
    const added = !!newProduct && !oldProduct

    return {
      ...product,
      deleted,
      added,
      quantityChange: {
        old: oldProduct?.quantity || 0,
        new: newProduct?.quantity || 0
      }
    }
  })

  return {
    ...order,
    mappedProducts,
    hasModifications
  }
}
